var map = {
	"./Counts": "./src/universal/collections/Counts.js",
	"./Counts.js": "./src/universal/collections/Counts.js",
	"./alerts/alerts": "./src/universal/collections/alerts/alerts.js",
	"./alerts/alerts.js": "./src/universal/collections/alerts/alerts.js",
	"./availabilities/methods": "./src/universal/collections/availabilities/methods.js",
	"./availabilities/methods.js": "./src/universal/collections/availabilities/methods.js",
	"./baseSchema": "./src/universal/collections/baseSchema.js",
	"./baseSchema.js": "./src/universal/collections/baseSchema.js",
	"./flights-type/flights-type": "./src/universal/collections/flights-type/flights-type.js",
	"./flights-type/flights-type.js": "./src/universal/collections/flights-type/flights-type.js",
	"./flights-type/options": "./src/universal/collections/flights-type/options.js",
	"./flights-type/options.js": "./src/universal/collections/flights-type/options.js",
	"./flights-type/places": "./src/universal/collections/flights-type/places.js",
	"./flights-type/places.js": "./src/universal/collections/flights-type/places.js",
	"./flights-type/prices": "./src/universal/collections/flights-type/prices.js",
	"./flights-type/prices.js": "./src/universal/collections/flights-type/prices.js",
	"./flights-type/promotions": "./src/universal/collections/flights-type/promotions.js",
	"./flights-type/promotions.js": "./src/universal/collections/flights-type/promotions.js",
	"./flights/flights": "./src/universal/collections/flights/flights.js",
	"./flights/flights.js": "./src/universal/collections/flights/flights.js",
	"./flights/methods": "./src/universal/collections/flights/methods.js",
	"./flights/methods.js": "./src/universal/collections/flights/methods.js",
	"./flights/places": "./src/universal/collections/flights/places.js",
	"./flights/places.js": "./src/universal/collections/flights/places.js",
	"./memos/memos": "./src/universal/collections/memos/memos.js",
	"./memos/memos.js": "./src/universal/collections/memos/memos.js",
	"./montgolfieres/montgolfieres": "./src/universal/collections/montgolfieres/montgolfieres.js",
	"./montgolfieres/montgolfieres.js": "./src/universal/collections/montgolfieres/montgolfieres.js",
	"./partners/group-bills": "./src/universal/collections/partners/group-bills.js",
	"./partners/group-bills-payments": "./src/universal/collections/partners/group-bills-payments.js",
	"./partners/group-bills-payments.js": "./src/universal/collections/partners/group-bills-payments.js",
	"./partners/group-bills.js": "./src/universal/collections/partners/group-bills.js",
	"./reservations/addresses": "./src/universal/collections/reservations/addresses.js",
	"./reservations/addresses.js": "./src/universal/collections/reservations/addresses.js",
	"./reservations/index.html": "./src/universal/collections/reservations/index.html",
	"./reservations/methods": "./src/universal/collections/reservations/methods.js",
	"./reservations/methods.js": "./src/universal/collections/reservations/methods.js",
	"./reservations/passengers": "./src/universal/collections/reservations/passengers.js",
	"./reservations/passengers.js": "./src/universal/collections/reservations/passengers.js",
	"./reservations/payments": "./src/universal/collections/reservations/payments.js",
	"./reservations/payments.js": "./src/universal/collections/reservations/payments.js",
	"./reservations/reservations": "./src/universal/collections/reservations/reservations.js",
	"./reservations/reservations.js": "./src/universal/collections/reservations/reservations.js",
	"./simpleSchema.config": "./src/universal/collections/simpleSchema.config.js",
	"./simpleSchema.config.js": "./src/universal/collections/simpleSchema.config.js",
	"./statistics/flights": "./src/universal/collections/statistics/flights.js",
	"./statistics/flights.js": "./src/universal/collections/statistics/flights.js",
	"./statistics/montgolfieres": "./src/universal/collections/statistics/montgolfieres.js",
	"./statistics/montgolfieres.js": "./src/universal/collections/statistics/montgolfieres.js",
	"./statistics/pilots": "./src/universal/collections/statistics/pilots.js",
	"./statistics/pilots.js": "./src/universal/collections/statistics/pilots.js",
	"./statistics/reservations": "./src/universal/collections/statistics/reservations.js",
	"./statistics/reservations.js": "./src/universal/collections/statistics/reservations.js",
	"./users/methods": "./src/universal/collections/users/methods.js",
	"./users/methods.js": "./src/universal/collections/users/methods.js",
	"./users/roles/god": "./src/universal/collections/users/roles/god.js",
	"./users/roles/god.js": "./src/universal/collections/users/roles/god.js",
	"./users/roles/organizer": "./src/universal/collections/users/roles/organizer.js",
	"./users/roles/organizer.js": "./src/universal/collections/users/roles/organizer.js",
	"./users/roles/partner": "./src/universal/collections/users/roles/partner.js",
	"./users/roles/partner.js": "./src/universal/collections/users/roles/partner.js",
	"./users/roles/pilot": "./src/universal/collections/users/roles/pilot.js",
	"./users/roles/pilot.js": "./src/universal/collections/users/roles/pilot.js",
	"./users/users": "./src/universal/collections/users/users.js",
	"./users/users.js": "./src/universal/collections/users/users.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3;



/*****************
 ** WEBPACK FOOTER
 ** ./src/universal/collections ^\.\/.*$
 ** module id = 3
 ** module chunks = 0
 **/